<template>
    <div class="content" ref="content" :style="{height: height > 300 ? 300 + 'px' : 'auto'}">
        <scrollbar occupy>
            {{ content }}
        </scrollbar>
    </div>
</template>

<script>
export default {
    name: 'alert',
    props: {
        content: {
            default: '',
            type: [String,Number]
        }
    },
    data: _=>({
        height: 0
    }),
    mounted() {
        let $content = this.$refs.content;
        this.height = $content.offsetHeight
    }
}
</script>

<style scoped>

    .content {
        width: 300px;
        padding: 30px 63px;
        font-size: 14px;
        color: #bedaff;
        background: #1C1F39;
    }
</style>